"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.DownloadFile = void 0;
const Name = exports.Name = 'download-file';
const DownloadFile = exports.DownloadFile = Name;
//# sourceMappingURL=index.js.map